import { useState, useEffect } from 'react';
import axios from 'axios';
import { Users, CheckCircle, Banknote, Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function MembershipPage() {
  const { t } = useLanguage();
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/membership-types/published`).then(r => setTypes(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-400">{t('contentPages.legal.loading')}</div>;

  return (
    <div className="min-h-screen bg-gray-50" data-testid="membership-page">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">{t('contentPages.membership.title')}</h1>
          <p className="text-gray-500">{t('contentPages.membership.subtitle')}</p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {types.length === 0 ? (
          <div className="bg-white rounded-lg shadow-sm p-12 text-center text-gray-400">
            {t('contentPages.membership.noData')}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {types.map(tp => (
              <div key={tp.id} className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden flex flex-col">
                <div className="bg-[#00A651] px-6 py-4">
                  <div className="flex items-center gap-2">
                    <Users className="h-5 w-5 text-white" />
                    <h2 className="text-lg font-bold text-white">{tp.name}</h2>
                  </div>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  {tp.fee && (
                    <div className="flex items-center gap-2 mb-4 text-2xl font-bold text-gray-900">
                      <Banknote className="h-5 w-5 text-[#00A651]" />
                      {tp.fee}
                    </div>
                  )}
                  {tp.conditions && (
                    <div className="mb-4">
                      <h3 className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-1">
                        <CheckCircle className="h-4 w-4 text-[#00A651]" />{t('contentPages.membership.conditions')}
                      </h3>
                      <p className="text-sm text-gray-600 whitespace-pre-wrap">{tp.conditions}</p>
                    </div>
                  )}
                  {tp.benefits && (
                    <div className="mb-4">
                      <h3 className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-1">
                        <Star className="h-4 w-4 text-[#00A651]" />{t('contentPages.membership.benefits')}
                      </h3>
                      <p className="text-sm text-gray-600 whitespace-pre-wrap">{tp.benefits}</p>
                    </div>
                  )}
                  {tp.description && (
                    <p className="text-sm text-gray-600 whitespace-pre-wrap mt-auto">{tp.description}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
